import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockPartsHover {
	static init() {
		this.blocks = document.querySelectorAll(".parts-hover");

		this.blocks.forEach(block => {
			let titles = block.querySelectorAll(".part-item");
			let images = block.querySelectorAll(".part-image img");
			let tags = block.querySelector(".part-col-right .tags");
			if (!tags) {
				return;
			}

			titles.forEach((title, index) => {
				const image = block.querySelector(`.part-image [data-part-index="${title.dataset.partIndex}"]`)
				title.addEventListener("mouseenter", () => {
					this.showImage(image, images);
					this.updateTags(title.dataset.partMarkets, tags);
				});
			});
		});
	}

	static showImage(image, images) {
		images.forEach(item => {
			item.classList.remove("active");
		});
		image.classList.add("active");
	}

	static updateTags(itemsText, tags) {
		gsap.to(tags, {
			opacity: 0,
			duration: 0.1,
			onComplete: () => {
				tags.innerHTML = "";
				const items = itemsText.split(",");
				items.forEach(item => {
					if (item) {
						tags.insertAdjacentHTML("afterbegin", `<div class="tag tag-dashed">${item}</div>`);
					}
				});
				gsap.to(tags, {opacity: 1, duration: 0.2});
			}
		});
	}
}
